import { render } from "./CadastroInicio.vue?vue&type=template&id=301351ba&scoped=true"
import script from "./CadastroInicio.vue?vue&type=script&lang=js"
export * from "./CadastroInicio.vue?vue&type=script&lang=js"

import "./CadastroInicio.vue?vue&type=style&index=0&id=301351ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-301351ba"]])

export default __exports__